export class BrowserHistoryHandler {
  public location: Location;
  constructor() {}
  public replace(path: string): void {
    window.history.replaceState(null, '', path);
  }
  public push(path: string): void {
    window.history.pushState(null, '', path);
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/infrastructure/adapter/BrowserHistoryHandler.ts